import { normalizeCSSColor, rgba } from "@tamagui/normalize-css-color";
import { rgba as rgba2 } from "@tamagui/normalize-css-color";
const normalizeColor = (color, opacity) => {
  if (!color)
    return;
  if (color[0] === "$" || color.startsWith("var("))
    return color;
  const colorProcessed = normalizeCSSColor(color);
  if (colorProcessed != null) {
    const { r, g, b, a } = rgba(colorProcessed), alpha = (opacity ?? a ?? 1).toFixed(2);
    return `rgba(${r},${g},${b},${alpha})`;
  }
  return process.env.NODE_ENV === "development" && console.warn(`Unknown color value: ${color}`), color;
};
export {
  normalizeColor,
  rgba2 as rgba
};
//# sourceMappingURL=normalizeColor.js.map
